// extracted by mini-css-extract-plugin
export default {"item":"UsersScreen_item__Af3Hb","tabTitle":"UsersScreen_tabTitle__7GPVK","tabContainer":"UsersScreen_tabContainer__+eRMt","tabColumn":"UsersScreen_tabColumn__65aoF"};